"use client"

import { Form, FormItemProps } from "antd"
import { FC } from "react"
import { Controller, ControllerProps } from "react-hook-form"

type ControllerWarpperProps = FormItemProps & {
  render: ControllerProps<any, any>['render'],
  control: ControllerProps<any, any>['control'],

}

const ControllerWarpper: FC<ControllerWarpperProps> = ({ render, control, name, ...props }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={(renderParams) => {
        const { error } = renderParams.fieldState

        return (
          <Form.Item
            {...props}
            {...(error ? {
              validateStatus: 'error',
              help: error.message
            } : {})}

          >
            {render(renderParams)}
          </Form.Item>
        )
      }}
    />
  )
}

export default ControllerWarpper